import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InstrumentTypeComponent } from './instrument-type.component';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {FuseSharedModule} from '../../../@fuse/shared.module';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';
import {MatButtonModule} from '@angular/material/button';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatSelectModule} from '@angular/material/select';
import {HttpLoaderFactory} from '../../pages/product/product.model';
import {HttpClient} from '@angular/common/http';



@NgModule({
    declarations: [
        InstrumentTypeComponent
    ],
    imports: [
        CommonModule,
        MatInputModule,
        MatIconModule,
        FuseSharedModule,
        TranslateModule,
        MatButtonModule,
        MatExpansionModule,
        MatTooltipModule,
        MatSelectModule
    ],
    exports: [
        InstrumentTypeComponent
    ]
})
export class InstrumentTypeModule { }
